import React from 'react'

const DarkModeIconInactive = ({ width, height }: { width?: number; height?: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 10} height={height || 12} viewBox="0 0 10 12">
      <g fill="none" fillRule="evenodd">
        <g fill="#859AA5" fillRule="nonzero">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="M4.821.015c.194-.01.336.184.255.357-.08.167-.15.335-.21.505-.02.055-.036.105-.052.155l-.001.004c-.88 2.772.799 5.717 3.581 6.43l.003.001c.044.012.088.022.133.033l.031.007c.175.038.354.068.537.089.188.02.274.244.168.402-.078.112-.16.22-.247.325-.071.086-.141.166-.213.243l-.016.017C7.685 9.755 6.033 10.4 4.24 10.11 2.18 9.78.495 8.156.098 6.104-.46 3.243 1.408.638 4.077.107l.018-.003c.1-.02.202-.037.305-.05l.007-.001c.136-.018.274-.03.414-.038zM3.697 1.267C1.945 1.897.774 3.695 1.06 5.695l.036.216c.316 1.63 1.664 2.93 3.306 3.194h.002c1.217.198 2.348-.14 3.203-.815-2.845-1.016-4.565-4.038-3.91-7.023z"
                      transform="translate(-55 -741) translate(19 734) translate(10 6) translate(26.09 1.91)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default DarkModeIconInactive
